import { render } from "./LeagueView.vue?vue&type=template&id=194c4674"
import script from "./LeagueView.vue?vue&type=script&lang=js"
export * from "./LeagueView.vue?vue&type=script&lang=js"

import "./LeagueView.vue?vue&type=style&index=0&id=194c4674&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__